import { render, staticRenderFns } from "./TranslationContainer.vue?vue&type=template&id=b9a93ec0&scoped=true"
import script from "./TranslationContainer.vue?vue&type=script&lang=js"
export * from "./TranslationContainer.vue?vue&type=script&lang=js"
import style0 from "./TranslationContainer.vue?vue&type=style&index=0&id=b9a93ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a93ec0",
  null
  
)

export default component.exports